import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import HomeGuestUserContent from "./HomeGuestUserContent";
import Scaffold from "../../../widget/layouts/Scaffold";
import { HomeGuestUserContextProvider } from "../../../provider/home_guest_user/guest_home/HomeGuestUserContextProvider";

const HomeGuestUserScreen = () => {
  const type: number = ResponsiveDeviceType();
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <HomeGuestUserContextProvider>
      <Scaffold appBarTitle={AppTranslation.text("")}>
        <MainBodyContainer
          className={`h-100 pt-4 pt-lg-5 ${
            type === 1 && height > 750 ? "d-flex align-items-center" : ""
          }`}
        >
          <HomeGuestUserContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </HomeGuestUserContextProvider>
  );
};

export default HomeGuestUserScreen;
export const routeName: string = "/guest";
